import { Colors, Services } from '@sigma-frontend-libs/commons'

import { components, getStorageURL, icons } from '@/utils'

import cancel from '@/components/services/report-manager/commons/actions/cancel'
import filterBy from '@/components/services/report-manager/commons/filterBy/tags'
import timeline from '@/components/services/report-manager/commons/timeline/mini'
import dateRange from '@/components/services/report-manager/queue/dateRange/tag'
import errors from '@/components/services/report-manager/queue/item/errors'
import { reportManagerQueueStatuses, service, serviceNameKebabCase, serviceNameViaPoint } from '@/components/services/report-manager/queue/utils'
import sticker from '@/components/sticker'
import actions from '@/components/templates/service/item/actions'
import date from '@/components/templates/service/item/date'
import owner from '@/components/templates/service/item/owner'

function renderName(h) {
  return h(
    sticker,
    {
      props: {
        value: this.value.name,
        icon: reportManagerQueueStatuses[this.value.status]?.icon,
        color: reportManagerQueueStatuses[this.value.status]?.color,
        iconTooltip: this.getTranslate(`${Services['report-manager']}.statuses.${this.value.status}`),
        label: this.getTranslate(`${Services['report-manager']}.labels.name`),
        badge: {
          'right-top': {
            value: this.value.runCount,
            color: Colors.grey,
            rounded: true,
            offset: 'out',
            tooltip: this.countTooltip
          }
        },
        button: this.downloadButton,
        to: {
          name: `${serviceNameViaPoint}.single`,
          params: { id: this.value.id }
        }
      }
    }
  )
}
function renderType(h) {
  if (this.viewport.size.width > 720) {
    return h(
      sticker,
      {
        props: {
          value: this.getTranslate(`${Services['report-manager']}.types.${this.value.type}`),
          label: this.getTranslate(`${Services['report-manager']}.labels.type`),
          icon: icons.list,
          iconTooltip: this.value.type,
          color: Colors.grey
        }
      }
    )
  }
}
function renderOwner(h) {
  if (this.viewport.size.width > 570) {
    return h(
      owner,
      {
        props: {
          value: this.value,
          width: 130
        }
      }
    )
  }
}
function renderInfo(h) {
  return h(
    'div',
    {
      class: `${serviceNameKebabCase}-item__info`
    },
    [
      renderName.call(this, h),
      renderType.call(this, h),
      renderOwner.call(this, h)
    ]
  )
}

function renderFilterBy(h) {
  if (this.viewport.size.width > 1800) {
    if (this.hasFilterBy) {
      return h(
        filterBy,
        {
          props: {
            value: this.value
          }
        }
      )
    }

    return h('div')
  }
}
function renderDateRange(h) {
  if (this.viewport.size.width > 1470) {
    if (this.value.dateRange) {
      return h(
        dateRange,
        {
          props: {
            value: this.value.dateRange,
            type: this.value.type
          }
        }
      )
    }

    return h('div')
  }
}
function renderTimeline(h) {
  if (this.viewport.size.width > 1350) {
    return h(
      'div',
      {
        class: 'fjcfe hover-child'
      },
      [
        h(
          timeline,
          {
            props: {
              value: this.value,
              service
            }
          }
        )
      ]
    )
  }
}

function renderDownload(h) {
  return h(
    components['list-item'],
    {
      props: {
        label: this.getTranslate('misc.buttons.download'),
        icon: icons.download,
        color: Colors.info,
        loading: this.fileLoading,
        disabled: !this.value.fileId || this.fileLoading || this.fileNotFound
      },
      on: {
        click: () => {
          window.location.href = getStorageURL([ this.value.fileId ])
        }
      }
    }
  )
}
function renderErrors(h) {
  return h(
    errors,
    {
      props: {
        data: this.value
      }
    }
  )
}
function renderCancel(h) {
  return h(
    cancel,
    {
      props: {
        value: this.value,
        service
      }
    }
  )
}
function renderActions(h) {
  return h(
    actions,
    {
      props: {
        value: this.value,
        actions: [ 'remove' ],
        service
      }
    },
    [
      renderDownload.call(this, h),
      renderCancel.call(this, h),
      renderErrors.call(this, h)
    ]
  )
}

function renderCreatedAt(h) {
  return h(
    date,
    {
      props: {
        value: this.value
      }
    }
  )
}

function renderDetails(h) {
  return h(
    'div',
    {
      class: `${serviceNameKebabCase}-item__details`
    },
    [
      renderDateRange.call(this, h),
      renderFilterBy.call(this, h),
      renderTimeline.call(this, h),
      renderActions.call(this, h),
      renderCreatedAt.call(this, h)
    ]
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: {
        'service-template-item hover-parent hover-parent--opacity': true,
        [`${serviceNameKebabCase}-item`]: true,
        [`${serviceNameKebabCase}-item--urgent`]: this.value.isUrgent
      }
    },
    [
      renderInfo.call(this, h),
      renderDetails.call(this, h)
    ]
  )
}
